var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2.8rem",
    height: 3,
    viewBox: "0 0 15 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C8C8C",
    strokeWidth: 2,
    d: "M.98 1.5h13.039"
  })));
}
export default SvgLine;